export var headers = {
	"Project-Id-Version": "open-xchange-appsuite-phishingchecker",
	"Report-Msgid-Bugs-To": "",
	"POT-Creation-Date": "",
	"PO-Revision-Date": "2022-05-14 21:17-0600",
	"Last-Translator": "Timothy Friesen <timothy@workshop-chapina.com>",
	Language: "en_GB",
	"Language-Team": "English <kde-i18n-doc@kde.org>",
	"Content-Type": "text/plain; charset=UTF-8",
	"Content-Transfer-Encoding": "8bit",
	"Plural-Forms": "nplurals=2; plural=(n != 1);",
	"MIME-Version": "1.0",
	"X-Generator": "Lokalize 19.12.3"
};
export default {
	headers: headers,
	"\u0000Anti-phishing Protection\u0001": [
	"Anti-phishing Protection"
],
	"\u0000You are attempting to open a potentially insecure link. Are you sure you want to proceed?\u0001": [
	"You are attempting to open a potentially insecure link. Are you sure you want to proceed?"
],
	"\u0000Open Link\u0001": [
	"Open Link"
],
	"\u0000Cancel\u0001": [
	"Cancel"
],
	"\u0000Invalid URL\u0001": [
	"Invalid URL"
],
	"\u0000URL you want to open is invalid. Cannot proceed.\u0001": [
	"URL you want to open is invalid. Cannot proceed."
],
	"\u0000Anti-phishing Protection is scanning your link...\u0001": [
	"Anti-phishing Protection is scanning your link..."
],
	"\u0000Phishing is the fraudulent attempt to obtain sensitive information or data, such as usernames, passwords and credit card details by directing users to enter their personal information at fake websites that look legitimate.\u0001": [
	"Phishing is the fraudulent attempt to obtain sensitive information or data, such as usernames, passwords and credit card details by directing users to enter their personal information at fake websites that look legitimate."
],
	"\u0000Anti-phishing protection will scan links in emails you receive to determine if it is safe for you to visit.\u0001": [
	"Anti-phishing protection will scan links in email messages you receive to determine if it is safe for you to visit."
],
	"\u0000Do not scan links in emails I receive.\u0001": [
	"Do not scan links in email messages I receive."
],
	"\u0000Only scan links in emails I receive within %s.\u0001": [
	"Only scan links in email messages I receive within %s."
],
	"\u0000Scan all links in emails I receive within %s and on third-party and mobile devices.\u0001": [
	"Scan all links in email messages I receive within %s and on third-party and mobile devices."
],
	"\u0000Scan links in emails I receive within %s.\u0001": [
	"Scan links in email messages I receive within %s."
],
	"\u0000Please select your level of protection:\u0001": [
	"Please select your level of protection:"
],
	"\u0000Anti-Phishing\u0001": [
	"Anti-Phishing"
]
};
